import React from "react";
import { Field } from "redux-form";
import * as agent from "../agent";
import MaterialContractSuggest from "./MaterialContractSuggest";
import MaterialAutocomplete from "./MaterialAutocomplete";
import {
    normalizeMoney,
    normalizeDecimal,
    required,
    validateTransactionDate
} from "../utility";
import { Transaction, Masks } from "../constants/enums";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import SubmitButton from "./SubmitButton";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

const transactionForm = ({
    allowedOperations = [],
    addTransaction,
    creditMode = false,
    copyMode = false,
    contractMode = false,
    importMode = false,
    isAdmin = false,
    inputAccount,
    alias,
    mustHaveContract,
    mustHaveDepartment,
    accounts = [],
    accountsLoaded,
    operations = [],
    operationSubgroups = [],
    selectSubgroup,
    selectedSubgroup,
    managersLoaded,
    managers = [],
    handleSubmit
}) => (
    <form
        className="common-form"
        onSubmit={handleSubmit(data => addTransaction(data))}
    >
        <Field
            component={MaterialTextField}
            select
            name="manager"
            validate={required}
            disabled={!managersLoaded || !isAdmin}
            label="Исполнитель"
        >
            {managers.map(({ _id, fullname }, i) => {
                const [
                    managerLastname,
                    managerFirstname = "",
                    managerThirdname = ""
                ] = fullname.split(" ");
                return (
                    <MenuItem
                        key={i}
                        value={_id}
                    >{`${managerLastname} ${managerFirstname[0]}. ${managerThirdname[0]}.`}</MenuItem>
                );
            })}
        </Field>
        <Field
            name="paymentDate"
            component={MaterialMaskedTextField}
            disabled={!isAdmin}
            validate={validateTransactionDate}
            mask={Masks.date}
            label="Дата платежа"
        />
        {!creditMode && !contractMode && !copyMode && (
            <TextField
                label="Подгруппа статей"
                select
                margin="dense"
                onChange={selectSubgroup}
                value={selectedSubgroup}
                variant="outlined"
                fullWidth
            >
                {operationSubgroups
                    .reduce(
                        (p, c) =>
                            p.concat(
                                [{ name: c._id, type: "group" }].concat(
                                    c.subgroups
                                )
                            ),
                        []
                    )
                    .map(({ name, _id, type }, i) => (
                        <MenuItem
                            disabled={type === "group"}
                            key={i}
                            value={_id}
                        >
                            {type === "group" ? (
                                <Typography variant="h6">{name}</Typography>
                            ) : (
                                ` > ${name}`
                            )}
                        </MenuItem>
                    ))}
            </TextField>
        )}
        {contractMode || creditMode ? (
            <Field
                component={MaterialTextField}
                select
                disabled={allowedOperations.length < 2}
                validate={required}
                name="operation"
                label="Статья ДДС"
            >
                {operations
                    .filter(({ alias, subgroup, editable }) =>
                        allowedOperations.includes(alias)
                    )
                    .map(({ name, _id }, i) => (
                        <MenuItem key={i} value={_id}>
                            {name}
                        </MenuItem>
                    ))}
            </Field>
        ) : (
            <Field
                component={MaterialAutocomplete}
                name="operation"
                validate={required}
                isTextarea={true}
                preloadedSuggestions={operations.filter(o =>
                    o.editable || copyMode
                        ? selectedSubgroup
                            ? o.subgroup._id === selectedSubgroup
                            : true
                        : false
                )}
                suggestionsPreloaded={true}
                formatTextValue={o => `${(o || {}).name}`}
                getSuggestionsMethod={(s, input) =>
                    s.name.toLowerCase().includes(input.toLowerCase())
                }
                label="Статья ДДС"
            />
        )}
        {mustHaveDepartment && (
            <Field
                component={MaterialTextField}
                select
                name="department"
                validate={required}
                label="Подразделение"
            >
                {Object.keys(Transaction.Departments).map((d, i) => (
                    <MenuItem key={i} value={d}>
                        {Transaction.Departments[d]}
                    </MenuItem>
                ))}
            </Field>
        )}
        <Field
            component={MaterialTextField}
            select
            name="account"
            disabled={!accountsLoaded}
            validate={required}
            label={
                alias === "TRANSFER_CREDIT"
                    ? "Учетный счет-отправитель"
                    : "Учетный счет"
            }
        >
            {accounts.map(({ name, _id }, i) => (
                <MenuItem key={i} value={_id}>
                    {name}
                </MenuItem>
            ))}
        </Field>
        {alias === "TRANSFER_CREDIT" && (
            <Field
                component={MaterialTextField}
                select
                name="accountReceiver"
                disabled={!accountsLoaded}
                validate={required}
                label="Учетный счет-получатель"
            >
                {accounts
                    .filter(a => a._id !== inputAccount)
                    .map(({ name, _id }, i) => (
                        <MenuItem key={i} value={_id}>
                            {name}
                        </MenuItem>
                    ))}
            </Field>
        )}
        {mustHaveContract && !contractMode && (
            <Field
                component={MaterialContractSuggest}
                name="contract"
                validate={required}
                label="Договор"
            ></Field>
        )}
        {!mustHaveContract && !creditMode && (
            <Field
                component={MaterialAutocomplete}
                name="counterparty"
                validate={required}
                formatTextValue={c => `${c.name}`}
                getInitialValue={agent.Counterparty.getById}
                getSuggestionsMethod={agent.Counterparty.getByName}
                disabled={creditMode}
                label="Контрагент"
            />
        )}
        <Field
            component={MaterialTextField}
            name="sum"
            normalize={importMode ? normalizeDecimal : normalizeMoney}
            validate={required}
            format={importMode ? normalizeDecimal : normalizeMoney}
            endAdornment="₽"
            label="Сумма"
        />
        <Field
            component={MaterialTextField}
            select
            name="vat"
            endAdornment="%"
            label="Ставка НДС"
        >
            <MenuItem value={0}>0</MenuItem>
            <MenuItem value={18}>18</MenuItem>
            <MenuItem value={20}>20</MenuItem>
        </Field>
        <Field
            name="comment"
            component={MaterialTextField}
            multiline={importMode}
            rows={importMode ? 3 : 0}
            label="Комментарий"
        />
        <SubmitButton label="Добавить" />
    </form>
);

export default transactionForm;



// WEBPACK FOOTER //
// ./src/components/TransactionForm.js